import { themedUseStyletron } from "../../../theme/customTheme";
import { getTimeRangeFromTimespan } from "../../../utils/timeUtils";
import GenericTimeline, { TGenericTimelineEvent, TGenericTimelineLabel } from "../../../components/Charts/GenericTimeline/GenericTimeline";
import { HistoricalDataItem, useGetByIdAndTimeQuery } from "../../../services/historicalData";
import { useMemo } from "react";
import { GenericTimeseriesStatistics } from "../../../components/Charts/GenericTimeseriesStatistics";
import { IMultiState } from "./types";
import {  VerticalStackPanel } from "../../../components/Layout/StackPanel";


const InsightsPanel = (props: IMultiState) => {
    const [css, theme] = themedUseStyletron()

    const colors = [
        theme.colors.accent100,
        theme.colors.accent200,
        theme.colors.accent300,
        theme.colors.accent400,
        theme.colors.accent500,
        theme.colors.accent600,
        theme.colors.accent700,
        theme.colors.accent100,
        theme.colors.accent200,
        theme.colors.accent300,
        theme.colors.accent400,
        theme.colors.accent500,
        theme.colors.accent600,
        theme.colors.accent700,
        theme.colors.accent100,
        theme.colors.accent200,
        theme.colors.accent300,
        theme.colors.accent400,
        theme.colors.accent500,
        theme.colors.accent600,
        theme.colors.accent700,

    ]
    const labels: TGenericTimelineLabel[] = props.stateTextList? JSON.parse(props.stateTextList).map((v, index) => {
        return {
            label: v,
            color: colors[index],
            value: index + 1
        }
    }): null

    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);
    const { data, isLoading, isSuccess, error } = useGetByIdAndTimeQuery(
        {
            id: props.id,
            start: timeRange.start.toUTCString(),
            end: timeRange.end.toUTCString(),
            propertyName: 'actState',
            resourceGroupId: props.resourceGroupId
        })

    const events = useMemo(() => mapItems(data ?? [], timeRange.start, timeRange.end), [data])
    return (
        props.stateTextList &&<>
    <VerticalStackPanel $alignItems={'stretch'}>
        <GenericTimeline currentValue={props.actState} labels={labels} data={events} start={timeRange.start} end={timeRange.end}></GenericTimeline>
        <GenericTimeseriesStatistics currentValue={props.actState} labels={labels} data={events} start={timeRange.start} end={timeRange.end}></GenericTimeseriesStatistics>
    </VerticalStackPanel>
    </>)
}

export default InsightsPanel




const mapItems = (data: HistoricalDataItem[], startDate: Date, endDate: Date) => {

    let result: TGenericTimelineEvent[] = [];
    for (let i = 0; i < data.length; i++) {
        if (i === 0)
            result.push({ startDate: startDate, endDate: new Date(data[i].timeStamp), value: data[i].value });

        let start = data[i].timeStamp;
        let end = i + 1 < data.length ? data[i + 1].timeStamp : endDate;
        result.push({ startDate: new Date(start), endDate: new Date(end), value: data[i].value });
    }

    return result;
}
